import * as React from 'react';
import {useEffect, useState} from 'react';

import {Exceptions, EXCLUDE_ST_LIMIT} from '../../exceptions/exceptions.class';
import {ExceptionsModal} from '../ExceptionsModal';
import {ShipStateExceptionsModal} from '../ShipStateExceptionsModal';
import {User} from '../../users/user.class';
import Button from '../../ui/Buttons/Button';

interface ExceptionIconsProps {
    alignLeft?: boolean;
    exceptions: Exceptions;
    user: User;
}

export const ExceptionIcons = ({alignLeft = false, exceptions, user}: ExceptionIconsProps) => {
    const [excludeStSeeMore, setExcludeStSeeMore] = useState(false);
    const [excludeStSeeMoreModal, setExcludeStSeeMoreModal] = useState(false);
    const [shortList, setShortList] = useState(exceptions.excludeStArray?.join(` `));
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        if (exceptions.excludeStArray?.length > 0) {
            if (shortList.length > EXCLUDE_ST_LIMIT) {
                setExcludeStSeeMore(true);
                setShortList(shortList.substring(0, EXCLUDE_ST_LIMIT));
            }
        }
    }, [exceptions.excludeStArray?.length, shortList]);

    /**
     * Template
     */
    return (
        <>
            <Button
                className={`!tw-flex tw-cursor-pointer tw-decoration-0 first:[&>img]:-tw-ml-3${
                    alignLeft ? ' !tw-justify-normal !tw-text-left' : ''
                }`}
                onClick={() => setShowModal(true)}
                size="sm"
                variant="link"
            >
                <>
                    {user?.hasCustomCatalogs() && !exceptions.itemNeedsAppr && (
                        <img
                            alt="Custom Catalog Icon"
                            className="tw-max-w-none tw-p-3 tw-cursor-pointer tw-mb-2"
                            height="48"
                            src="/btns/custom-catalog-icon.gif"
                            title="Approved for your custom catalog"
                            width="48"
                        />
                    )}
                    {(exceptions.prop65b_b === true || exceptions.prop65c_b === true || exceptions.prop65Message) && (
                        <img
                            alt="California Proposition 65 Icon"
                            className="tw-max-w-none tw-p-3 tw-cursor-pointer tw-mb-2"
                            height="48"
                            src="/btns/warning.png"
                            title={`${exceptions.prop65Message}`}
                            width="52"
                        />
                    )}
                    {exceptions.canShipAir === false && (
                        <img
                            alt="Product cannot be shipped AIR freight"
                            className="tw-max-w-none tw-p-3 tw-cursor-pointer tw-mb-2"
                            height="48"
                            src="/dimg/AirshipExclusion.png"
                            title="Product cannot be shipped AIR freight"
                            width="48"
                        />
                    )}
                    {exceptions.excludeStArray && exceptions.excludeStArray.length > 0 && (
                        <img
                            alt="Product cannot ship to some locations"
                            className="tw-max-w-none tw-p-3 tw-cursor-pointer tw-mb-2"
                            height="48"
                            src="/dimg/StateShipExclusion.png"
                            title="Product cannot ship to some locations"
                            width="48"
                        />
                    )}
                    {exceptions.upsHazard && (
                        <img
                            alt="HazMat charges apply"
                            className="tw-max-w-none tw-p-3 tw-cursor-pointer tw-mb-2"
                            height="48"
                            src="/dimg/HazardousFreightCharge.png"
                            title="HazMat charges apply"
                            width="48"
                        />
                    )}
                    {exceptions.ormd && (
                        <img
                            alt="LQTY Product"
                            className="tw-max-w-none tw-p-3 tw-cursor-pointer tw-mb-2"
                            height="48"
                            src="/dimg/ORM_D.png"
                            title="LQTY Product"
                            width="48"
                        />
                    )}
                    {(exceptions.lotTrack || exceptions.lottracking) && (
                        <img
                            alt="Lot Tracked Item"
                            className="tw-max-w-none tw-p-3 tw-cursor-pointer tw-mb-2"
                            height="48"
                            src="/dimg/LotTrackedItem.png"
                            title="Lot Tracked Item"
                            width="48"
                        />
                    )}
                    {(exceptions.sdsLink || exceptions.msdsavail || exceptions.graMsdsavail_b) && (
                        <img
                            alt="SDS Sheet Available"
                            className="tw-max-w-none tw-p-3 tw-cursor-pointer tw-mb-2"
                            height="48"
                            src="/dimg/SDSSheet.png"
                            title="SDS Sheet Available"
                            width="48"
                        />
                    )}
                    {exceptions.bin && (
                        <img
                            alt="Labeled in shop"
                            className="tw-max-w-none tw-p-3 tw-cursor-pointer tw-mb-2"
                            height="48"
                            src="/dimg/ItemLabeledInShop.png"
                            title="Labeled in shop"
                            width="48"
                        />
                    )}
                </>
            </Button>
            <ExceptionsModal
                exceptions={exceptions}
                excludeStSeeMore={excludeStSeeMore}
                onHide={() => {
                    setShowModal(false);
                }}
                onSeeAll={() => setExcludeStSeeMoreModal(true)}
                shortlist={shortList}
                show={showModal}
                user={user}
            />
            <ShipStateExceptionsModal
                onHide={() => {
                    setExcludeStSeeMoreModal(false);
                }}
                shipStateExclusions={exceptions.excludeStArray}
                show={excludeStSeeMoreModal}
            />
        </>
    );
};
